import "./Channel.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// import HomeMediman from "./HomeMediman";
import channelUserApi from "../../apis/ChannelUser.api";
import { setFirstInflow } from "../../redux/store/channel/channelDuck";

import Home from "./Home";
// import {useEffect, useState} from "react";
// import {loginLog} from "../../utils/useUser";
// import moment from "moment";
import HomeSquidtv from "./HomeSquidtv";

const Channel = () => {
	const dispatch = useDispatch();

	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const firstInflow = useSelector((state) => state.channel.firstInflow);

	// const [isMobile, setIsMobile] = useState(null);
	// useEffect(() => {
	//     if (typeof window !== 'undefined') {
	//         const matchQueryList = window.matchMedia('all and (max-width: 768px)');
	//         setIsMobile(matchQueryList.matches);
	//
	//         function handleChange(e) {
	//             setIsMobile(e.matches);
	//         }
	//
	//         matchQueryList.addEventListener("change", handleChange);
	//     }
	// }, []);

	useEffect(() => {
		if (reduxChannel?.user_id) {
			if (!firstInflow) {
				dispatch(setFirstInflow(true));
				addUserHistory();
			}
		}
	}, [firstInflow, reduxChannel]);

	const addUserHistory = async () => {
		const param = {
			action: "first_inflow",
			created_by: 1,
			influencer_id: reduxChannel?.user_id,
		};
		await channelUserApi.userHistory(param);
	};

	return (
		<div className="channel-wrap channel-home">
			{reduxChannel?.user_id === 9 ? (
				// 	reduxChannel?.influencer_id === "admin" ||
				// reduxChannel?.influencer_id === "squidtv"
				// <HomeMediman isMobile={isMobile}/>
				<HomeSquidtv />
			) : (
				<Home />
			)}
		</div>
	);
};
export default Channel;
